import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"close-on-content-click":false,"content-class":_vm.useContentClass,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true),model:{value:(_vm.showHelpBox),callback:function ($$v) {_vm.showHelpBox=$$v},expression:"showHelpBox"}},[_c('div',{staticClass:"helpBoxContainer"},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }